import { createSelector } from '@ngrx/store';

import { Comparer } from '@common/services';
import { PataConstants } from '@apps/pata/pata.constants';
import { filterQuickSearch } from '@common/services/utils.service';

import { getPataState, IPataState } from '../pata.state';
import { PataCopilFeatureKey, IPataCopilsState, copilsAdapter } from './copils.state';
import { Copil } from '@apps/pata/domain/models/copil';
import { DetailedCopil } from '@apps/pata/domain/models/detailed-copil';

const getPataCopilState = createSelector(
    getPataState,
    (state: IPataState) =>
        state[PataCopilFeatureKey]
);
const getProjectsCollection = createSelector(
    getPataCopilState,
    (state: IPataCopilsState) => state.copils
);
export const {
    selectAll: getAllCopils,
    selectTotal: nbProjects
} = copilsAdapter.getSelectors(getProjectsCollection);

export const getCopilsDoneFilter = createSelector(
    getPataCopilState,
    (state): boolean | null =>
        state.doneFilter
);
const getQuickSearchedCopils = createSelector(
    getPataCopilState,
    getAllCopils,
    (state: IPataCopilsState, copils: Copil[]): Copil[] =>
        filterQuickSearch(copils, state.qsWord, PataConstants.CopilsQSFields)
);
const getQuickFilterCopils = createSelector(
    getQuickSearchedCopils,
    getCopilsDoneFilter,
    (copils: Copil[], filter: boolean | null): Copil[] =>
        copils.filter((c: Copil): boolean =>
            filter === null || c.planified === filter
        )
);
export const getPipelinedCopils = createSelector(
    getQuickFilterCopils,
    (copils: Copil[], params: { comparer: Comparer<Copil> }): Copil[] =>
        [...copils].sort(params.comparer)
);
export const countCopils = createSelector(
    getAllCopils,
    (allCopils): number =>
        allCopils.length
);
export const getLoadingStatus = createSelector(
    getPataCopilState,
    (state): boolean => state.isLoading
);
export const getLoadedStatus = createSelector(
    getPataCopilState,
    (state): boolean => state.isLoaded
);
export const getOupsStatus = createSelector(
    getPataCopilState,
    (state): boolean => state.isOups
);
export const getEmptyStatus = createSelector(
    getPataCopilState,
    (state): boolean => state.isEmpty
);
export const getSelectedCopil = createSelector(
    getPataCopilState,
    (state): DetailedCopil => state.selectedCopil
);
